import './variables.css';

import { css } from '@emotion/react';

import { colors, fonts, fontSizes, fontWeights, lineHeights } from './styles';

export const globalStyles = css`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap');

  html {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
  }

  * {
    box-sizing: border-box;
    font-family: ${fonts.base};
    -webkit-font-smoothing: antialiased;
  }

  body {
    font-size: 16px;
    font-size: ${fontSizes.base};
    font-family: ${fonts.base};
    font-weight: normal;
    line-height: ${lineHeights.normal};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeSpeed;
  }

  ::selection,
  ::-moz-selection {
    background: ${colors.olive['500']};
    color: ${colors.light['100']};
  }

  *,
  *:focus {
    outline: none;
  }

  *:focus-visible {
    outline: 2px solid ${colors.olive['700']};
  }

  a {
    color: ${colors.gray['900']};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  b,
  strong {
    font-weight: ${fontWeights.bold};
  }

  ul,
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }
`;

export const GlobalStyle = css`
  ${globalStyles}
`;
